export default __webpack_public_path__ + "static/media/keen.930ea185.svg";